import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { UserAPI } from 'api/user';
import { UserCreationProps } from 'contexts/project-creation';
import { added } from 'stores/users';
import { createMember } from '../actions';
import { addUser, setMembersLoading } from '../slice';

interface Callback {
  (data: any): void;
}

interface UserPayloadProps {
  data: UserCreationProps;
  successCallback?: Callback;
  failureCallback?: Callback;
}

function* createMemberSaga(action: PayloadAction<UserPayloadProps>) {
  const { payload } = action;
  const { data, successCallback, failureCallback } = payload;

  try {
    yield put(setMembersLoading(true));
    const user = yield UserAPI.createUser(data);

    yield put(addUser(user));
    yield put(added(user));

    if (successCallback) {
      successCallback(user);
    }
  } catch (error) {
    if (failureCallback) {
      failureCallback(error);
    }
  } finally {
    yield put(setMembersLoading(false));
  }
}

export const watchCreateMemberSaga = function* (): Generator {
  yield takeLatest(createMember.type, createMemberSaga);
};
